var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{directives:[{name:"hammer",rawName:"v-hammer:tap",value:(_vm.tap),expression:"tap",arg:"tap"}],staticClass:"ui-text",domProps:{"innerHTML":_vm._s(_vm.html)}})}
var staticRenderFns = []

export { render, staticRenderFns }